/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowcoverphoto3Inputs */

const en_aiflowcoverphoto3 = /** @type {(inputs: Aiflowcoverphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use your own photo`)
};

const de_aiflowcoverphoto3 = /** @type {(inputs: Aiflowcoverphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenes Foto verwenden`)
};

/**
* | output |
* | --- |
* | "Use your own photo" |
*
* @param {Aiflowcoverphoto3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowcoverphoto3 = /** @type {((inputs?: Aiflowcoverphoto3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowcoverphoto3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowcoverphoto3(inputs)
	return de_aiflowcoverphoto3(inputs)
});
export { aiflowcoverphoto3 as "aiFlowCoverPhoto" }